document.addEventListener("DOMContentLoaded", function () {
    const countdownElement = document.getElementById("countdown-message");

    function updateCountdown() {
        const now = new Date();
        const day = now.getDay();
        let deadline;

        // Definir la hora límite según el día de la semana
        if (day >= 1 && day <= 5) {
            // Lunes a Viernes hasta las 17:00
            deadline = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 17, 0, 0);
        } else if (day === 6) {
            // Sábado hasta las 15:00
            deadline = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 15, 0, 0);
        } else {
            // Domingo hasta las 14:00
            deadline = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 14, 0, 0);
        }

        // Si ya pasó la hora límite, se setea al día siguiente
        if (now > deadline) {
            deadline.setDate(deadline.getDate() + 1);
        }

        // Calcular la diferencia en tiempo
        const remainingTime = deadline - now;

        // Calcular horas, minutos y segundos
        const hours = Math.floor((remainingTime / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((remainingTime / (1000 * 60)) % 60);
        const seconds = Math.floor((remainingTime / 1000) % 60);

        // Mostrar el temporizador
       countdownElement.innerHTML = `
    <div style="text-align: center;">
        <span style="color:black; display: block; font-size: 1.1em; margin-bottom: 2px;">Si eres de Región Metropolitana</span>
        <span style="color:black;">Compra en las próximas </span>
        <span style="color:red; font-weight: bold;">${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s</span>
    </div>
`;
    }

    // Actualizar cada segundo
    setInterval(updateCountdown, 1000);
});